// Constants.
import * as ConfigConstants from 'constants/ConfigConstants';
import * as StatsChartsConstants from 'constants/StatsChartsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as PayProductsConstants from 'constants/PayProductsConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  chartsFlowHaveData: [],
};

export default function chartsData(state = initialState, action = {}) {
  switch (action.type) {
    case StatsChartsConstants.LOAD_CHARTS_FLOW_HAVE_DATA_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case StatsChartsConstants.LOAD_CHARTS_FLOW_HAVE_DATA_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        chartsFlowHaveData: action.chartsFlowHaveData,
      };
    case ConfigConstants.LOAD_CONFIG_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        chartsFlowHaveData: [],
      };
    case PayProductsConstants.PAY_PRODUCT_SUCCESS:
    case AuthConstants.LOGIN_SUCCESS:
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        chartsFlowHaveData: [],
      };
    default:
      return state;
  }
}
